/** "24 hours", "1 hour", or whole days from two days up ("7 days"); an odd count such as 36 stays in hours. Mirrors the invitation email's wording. */
export function lifetimeText(hours: number): string {
  if (hours >= 48 && hours % 24 === 0) return `${hours / 24} days`;
  return hours === 1 ? '1 hour' : `${hours} hours`;
}
